import React, { useRef, useState } from "react";
import Logo from "../../images/logo.png";
import LogoDark from "../../images/logo.png";
import Head from "../../layout/head/Head";
import AuthFooter from "./AuthFooter";
import {
  Block,
  BlockContent,
  BlockDes,
  BlockHead,
  BlockTitle,
  Button,
  Icon,
  PreviewCard,
} from "../../components/Component";
import { Form, Spinner, Alert } from "reactstrap";
import { useForm } from "react-hook-form";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { adminLoginAPI } from "../../api/login/indes";
import { decrypt, encrypt } from "../../utils/Utils";
import { toast } from "react-toastify";
import Captcha from "../../MyComp/UI/Captcha/Captcha";
import axios from "axios";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const encryptedData = localStorage.getItem("userDetail");
  const userData = encryptedData ? decrypt(encryptedData) : null;
  const token = localStorage.getItem("accessToken");
  const [loading, setLoading] = useState(false);
  const [passState, setPassState] = useState(false);
  const [errorVal, setError] = useState("");
  const [captchaValid, setCaptchaValid] = useState(false);
  const [captchaTouched, setCaptchaTouched] = useState(false);
  const [captchaError, setCaptchaError] = useState(null); // To track if CAPTCHA has been interacted with
  const captchaRef = useRef(null);

  const onFormSubmit = async (formData) => {
    try { 
      setCaptchaTouched(true);
      if (!captchaValid) {
        setCaptchaError("Captcha is required");
        captchaRef.current.resetCaptcha();
        return;
      }
      setLoading(true);
      const response = await axios.get("https://ipinfo.io/json?token=7ef19370e91880");
      const ipAddress = response.data.ip;

      // Retrieve OS and browser information
      const os = navigator.platform;
      const userAgent = navigator.userAgent;
      let browserName = "";
      if (userAgent.includes("Firefox")) {
        browserName = "Mozilla Firefox";
      } else if (userAgent.includes("Chrome") && !userAgent.includes("Chromium")) {
        browserName = "Google Chrome";
      } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
        browserName = "Safari";
      } else if (userAgent.includes("MSIE") || userAgent.includes("Trident")) {
        browserName = "Internet Explorer";
      } else if (userAgent.includes("Edge") || userAgent.includes("Edg")) {
        browserName = "Microsoft Edge";
      } else {
        browserName = "Unknown Browser";
      }
      setLoading(true);
      const myKey = Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000;
      const body = {
        email: formData.name,
        password: formData.passcode,
        os: os,
        browser: browserName,
        ip: ipAddress,
        magic: encrypt(myKey),
      };
      const b = {
        en: encrypt(body),
      };
      adminLoginAPI(b)
        .then((res) => {
          const status = decrypt(res?.data?.status || "");
          if (status === "success") {
            const decryptedData = decrypt(res?.data?.data || "");
            if (status === "success" && decryptedData?.magic == myKey) {
              setLoading(false); 
              toast.success("You have logged in successfully!");
              localStorage.setItem("accessToken", decryptedData.token);
              localStorage.setItem("userDetail", res.data.data);
              navigate("/dashboard");
            } else if (status === "failed") {
              toast.error(res.data.message);
              captchaRef.current.resetCaptcha();
              setLoading(false);
            }
          } else if (status === "failed") {
            toast.error(res.data.message);
            captchaRef.current.resetCaptcha();
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          captchaRef.current.resetCaptcha();
        });
    } catch (error) {
      setLoading(false);
      console.log("AWEr",error);
      // captchaRef.current.resetCaptcha();
    } finally {
      setLoading(false);
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  return (
    <>
      <Head title="Login" />
      <Block className="nk-block-middle nk-auth-body  wide-xs">
        <div className="brand-logo pb-4 text-center">
          <Link to={process.env.PUBLIC_URL + "/"} className="logo-link">
            <img className="logo-light logo-img logo-img-lg" src={Logo} alt="logo" />
            <img className="logo-dark logo-img logo-img-lg" src={LogoDark} alt="logo-dark" />
          </Link>
        </div>

        <PreviewCard className="card-bordered" bodyClass="card-inner-lg">
          <BlockHead>
            <BlockContent>
              <BlockTitle tag="h4">Sign-In</BlockTitle>
              <BlockDes>
                <p>Access Admin Panel using your email and password.</p>
              </BlockDes>
            </BlockContent>
          </BlockHead>
          {errorVal && (
            <div className="mb-3">
              <Alert color="danger" className="alert-icon">
                <Icon name="alert-circle" /> Unable to login with credentials{" "}
              </Alert>
            </div>
          )}
          <Form className="is-alter" onSubmit={handleSubmit(onFormSubmit)}>
            <div className="form-group">
              <div className="form-label-group">
                <label className="form-label" htmlFor="default-01">
                  Email or Username
                </label>
              </div>
              <div className="form-control-wrap">
                <input
                  type="text"
                  id="default-01"
                  {...register("name", { required: "This field is required" })}
                  defaultValue="admin@demo.com"
                  placeholder="Enter your email address or username"
                  className="form-control-lg form-control"
                />
                {errors.name && <span className="invalid">{errors.name.message}</span>}
              </div>
            </div>
            <div className="form-group">
              <div className="form-label-group">
                <label className="form-label" htmlFor="password">
                  Password
                </label>
                <Link className="link link-primary link-sm" to={`${process.env.PUBLIC_URL}/auth-reset`}>
                  Forgot Password?
                </Link>
              </div>
              <div className="form-control-wrap">
                <a
                  href="#password"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setPassState(!passState);
                  }}
                  className={`form-icon lg form-icon-right passcode-switch ${passState ? "is-hidden" : "is-shown"}`}
                >
                  <Icon name="eye" className="passcode-icon icon-show"></Icon>

                  <Icon name="eye-off" className="passcode-icon icon-hide"></Icon>
                </a>
                <input
                  type={passState ? "text" : "password"}
                  id="password"
                  {...register("passcode", { required: "This field is required" })}
                  defaultValue="Admin@123"
                  placeholder="Enter your password"
                  className={`form-control-lg form-control ${passState ? "is-hidden" : "is-shown"}`}
                />
                {errors.passcode && <span className="invalid">{errors.passcode.message}</span>}
              </div>
            </div>
            <Captcha ref={captchaRef} setCaptchaValid={setCaptchaValid} setCaptchaError={setCaptchaError} />
            {captchaTouched && (
              <span className="invalid" style={{ color: "#e85347", fontSize: "11px", fontStyle: "italic" }}>
                {captchaError}
              </span>
            )}
            <div className="form-group">
              <Button size="lg" className="btn-block" type="submit" color="primary">
                {loading ? <Spinner size="sm" color="light" /> : "Sign in"}
              </Button>
            </div>
          </Form>
        </PreviewCard>
      </Block>
      <AuthFooter />
    </>
  );
};
export default Login;
